module.exports = __webpack_public_path__ + "img/ArgIslan5.4e4943b3.jpg";